let config;
try {
  const mod = require('./' + process.env.REACT_APP_PROJECT_NAME + '-utils-config');
  config = mod.default || mod;
} catch (e) {
  config = {};
}
export default config;
